export default class Country {
    constructor($rootElement) {
        this.$rootElement = $rootElement;
    }

    getCurrentCountry() {
        return this.$rootElement.attr('data-country');
    }
}

Country.$inject = ['$rootElement'];
